import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Tab } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";

import Layout from "../../shared/Layout";
import PersonalData from "./components/PersonalData/PersonalData";
import Password from "./components/Password/Password";
import Certificates from "./components/Certificates/Certificates";
import { Title, FastTab } from "./Profile.styles";
import FastBreadcrumbs from "../../shared/FastBreadcrumbs";
import { profileService } from "../../services/profile.service";
import useSnackBar from "../../hooks/useSnackBar";
import { AuthContext } from "../../context/AuthProvider";

const Profile = () => {
  const { setSnackBar } = useSnackBar();
  const [value, setValue] = useState("1");
  const { authenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [info, setInfo] = useState<any>({
    avatar: "",
    biography: "",
    patronymic: "",
    certificates: [],
    competence: "",
    first_name: "",
    last_name: "",
    second_name: "",
    link_site: "",
    link_facebook: "",
    link_instagram: "",
    link_linkedin: "",
    link_twitter: "",
    link_youtube: "",
  });
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!authenticated) {
      navigate("/");
    }
    const fetchProfile = async () => {
      try {
        const response = await profileService.getProfileFull();
        setInfo(response.data);
      } catch (e: any) {
        setSnackBar({
          title: e.response.data.detail,
          isActive: true,
          status: "error",
        });
      }
    };

    fetchProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const links = [
    { name: "Главная", link: "/" },
    { name: "Профиль", link: "/profile" },
  ];
  return (
    <Layout>
      <FastBreadcrumbs links={links} />
      <Title>Профиль</Title>
      <Box
        sx={{
          width: "100%",
          typography: "body1",
          "@media (max-width: 1000px)": {
            padding: "0 16px",
          },
        }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label={<FastTab>Личные данные</FastTab>} value="1" />
              <Tab label={<FastTab>Безопасность</FastTab>} value="2" />
              <Tab label={<FastTab>Мои сертификаты</FastTab>} value="3" />
            </TabList>
          </Box>

          <TabPanel
            value="1"
            sx={{
              "@media (max-width: 1000px)": {
                p: "24px 0",
              },
            }}>
            <PersonalData info={info} setInfo={setInfo} />
          </TabPanel>

          <TabPanel
            value="2"
            sx={{
              "@media (max-width: 1000px)": {
                p: "24px 0",
              },
            }}>
            <Password />
          </TabPanel>

          <TabPanel
            value="3"
            sx={{
              "@media (max-width: 1000px)": {
                p: "24px 0",
              },
            }}>
            <Certificates info={info} setInfo={setInfo} />
          </TabPanel>
        </TabContext>
      </Box>
    </Layout>
  );
};

export default Profile;
